import { IResourceComponentsProps } from '@pankod/refine-core';
import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { useParams } from 'react-router-dom';
import { formatDateTime } from 'utils';
import { getTrackDlPurchase } from 'apis/track-purchase';

export const TrackPurchasesDlShow: React.FC<IResourceComponentsProps> = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const subDownload = searchParams.get('sub-download');

    const [tracks, setTracks] = useState<any>();
    const handleGetTrackDlPurchase = useCallback(async (id, payload) => {
        const res = await getTrackDlPurchase(id, payload);
        setTracks(res.data);
    }, []);

    useEffect(() => {
        if (id && subDownload === 'true') {
            handleGetTrackDlPurchase(id, { type: 'subscription' });
        }
        if (id && subDownload === 'false') {
            handleGetTrackDlPurchase(id, { type: 'cash' });
        }
    }, [handleGetTrackDlPurchase, id, subDownload]);

    return (
        <div style={{ marginTop: '20px' }}>
            <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>Track detail:</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '35px' }}>
                <p style={{ width: '13%', fontWeight: 500, color: '#000' }}>Date</p>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Label</p>
                <p style={{ width: '45%', fontWeight: 500, color: '#000' }}>Title</p>
                <p style={{ width: '18%', fontWeight: 500, color: '#000' }}>User email</p>
                <p style={{ width: '10%', fontWeight: 500, color: '#000' }}>IpAddress</p>
            </div>
            {(tracks || []).map((item: any, index: any) => {
                return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ width: '13%' }}>{formatDateTime(item?.createdAt)}</p>
                        <p style={{ width: '14%' }}>{item?.nameLabel}</p>
                        <p style={{ width: '45%' }}>{item?.trackTitle}</p>
                        <p style={{ width: '18%' }}>{item.buyerEmail}</p>
                        <p style={{ width: '10%' }}>{item?.ipAddress}</p>
                    </div>
                );
            })}
        </div>
    );
};
